import { HomeIcon } from "@heroicons/react/24/outline";
import { DashboardIcon } from "src/icons";
import { BillingIcon } from "src/icons/BillingIcon";
import { CalendarIcon } from "src/icons/CalendarIcon";
import { CourseIcon } from "src/icons/CourseIcon";
import DataExportIcon from "src/icons/DataExportIcon";
import { EnquiryIcon } from "src/icons/EnquiryIcon";
import { ExpenseIcon } from "src/icons/ExpenseIcon";
import InventoryIcon from "src/icons/InventoryIcon";
import InventoryManagementIcon from "src/icons/InventoryManagementIcon";
import InventoryRequestIcon from "src/icons/InventoryRequestIcon";
import { MembershipIcon } from "src/icons/MembershipIcon";
import { PackageIcon } from "src/icons/PackageIcon";
import { PlansIcon } from "src/icons/PlansIcon";
import ProcurementIcon from "src/icons/ProcurementIcon";
import ProductIcon from "src/icons/ProductIcon";
import { RolesIcon } from "src/icons/RolesIcon";
import { SettingsIcon } from "src/icons/SettingsIcon";
import { StaffIcon } from "src/icons/StaffIcon";
import { StoreIcon } from "src/icons/StoreIcon";
import { UserIcon } from "src/icons/UserIcon";
import VendorIcon from "src/icons/VendorIcon";
import { VoucherIcon } from "src/icons/VoucherIcon";
import { WithdrawIcon } from "src/icons/WithdrawIcon";
import { ACTIVE_VIEW } from "src/utils/constants";

export const TAB_NAMES = {
  DASHBOARD: "DASHBOARD",
  STORE: "STORE",
  USERS: "USERS",
  ROLES: "ROLES",
  STORES: "STORES",
  SETTINGS: "SETTINGS",
  EDIT_PROFILE_SETTINGS: "EDIT_PROFILE_SETTINGS",
  MODULES: "MODULES",
  PEOPLE: "PEOPLE",
  PLANS: "PLANS",
  SELECT_PLAN: "SELECT_PLAN",
  APPOINTMENT: "APPOINTMENT",
  CLIENT_MANAGEMENT: "CLIENT_MANAGEMENT",
  STAFF_MANAGEMENT: "STAFF_MANAGEMENT",
  SERVICE_MANAGEMENT: "SERVICE_MANAGEMENT",
  PACKAGE_MANAGEMENT: "PACKAGE_MANAGEMENT",
  COURSE_MANAGEMENT: "COURSE_MANAGEMENT",
  MEMBERSHIP_MANAGEMENT: "MEMBERSHIP_MANAGEMENT",
  COUPON_MANAGEMENT: "COUPON_MANAGEMENT",
  ENQUIRY_MANAGEMENT: "ENQUIRY_MANAGEMENT",
  BILLING: "BILLING",
  EXPENSES: "EXPENSES",
  WITHDRAW: "WITHDRAW",
  INVENTORY_MANAGEMENT: "INVENTORY_MANAGEMENT",
  ALL_INVENTORY: "ALL_INVENTORY",
  STORE_INVENTORY: "STORE_INVENTORY",
  INVENTORY_REQUEST: "INVENTORY_REQUEST",
  VENDOR_MANAGEMENT: "VENDOR_MANAGEMENT",
  PROCUREMENT_REQUEST: "PROCUREMENT_REQUEST",
  PURCHASE_ORDER: "PURCHASE_ORDER",
  DATA_EXPORT: "DATA_EXPORT",
  PRODUCTS: "PRODUCTS",
  EDIT_STORE_SETTINGS: "EDIT_STORE_SETTINGS",
};

export const superAdminNavOptions = [
  {
    label: "Dashboard",
    name: TAB_NAMES.DASHBOARD,
    href: "/",
    icon: DashboardIcon,
  },
  {
    label: "Stores",
    name: TAB_NAMES.STORES,
    href: "/stores",
    icon: StoreIcon,
  },
  {
    label: "Users",
    name: TAB_NAMES.USERS,
    href: "/users",
    icon: UserIcon,
  },
  {
    label: "Plans",
    name: TAB_NAMES.PLANS,
    href: "/plans",
    icon: PlansIcon,
  },
  {
    label: "Roles",
    name: TAB_NAMES.ROLES,
    href: "/roles",
    icon: RolesIcon,
  },
];

export const subAdminNavOptions = [
  {
    label: "Sub-Admin Dashboard",
    name: TAB_NAMES.DASHBOARD,
    href: "/",
    icon: HomeIcon,
  },
];

export const adminNavOptions = [
  {
    label: "Dashboard",
    name: TAB_NAMES.DASHBOARD,
    href: "/store/dashboard",
    icon: DashboardIcon,
  },
  {
    label: "Appointments",
    name: TAB_NAMES.APPOINTMENT,
    href: "/store/appointments",
    icon: CalendarIcon,
  },
  {
    label: "Client Management",
    name: TAB_NAMES.CLIENT_MANAGEMENT,
    href: "/store/clients",
    icon: UserIcon,
  },
  {
    label: "Staff Management",
    name: TAB_NAMES.STAFF_MANAGEMENT,
    href: "/store/staff",
    icon: StaffIcon,
  },
  {
    label: "Manage",
    name: "Manage",
    // href: "/staff",
    icon: RolesIcon,
    expanded: false,
    children: [
      {
        label: "Service Management",
        name: TAB_NAMES.SERVICE_MANAGEMENT,
        href: "/store/services",
        icon: SettingsIcon,
      },
      {
        label: "Package Management",
        name: TAB_NAMES.PACKAGE_MANAGEMENT,
        href: "/store/packages",
        icon: PackageIcon,
      },
      {
        label: "Course Management",
        name: TAB_NAMES.COURSE_MANAGEMENT,
        href: "/store/courses",
        icon: CourseIcon,
      },
    ],
  },
  {
    label: "Inventory Management",
    name: TAB_NAMES.INVENTORY_MANAGEMENT,
    icon: InventoryManagementIcon,
    children: [
      {
        label: "Inventory",
        name: TAB_NAMES.INVENTORY_MANAGEMENT,
        href: "/store/inventory",
        icon: InventoryIcon,
      },
      {
        label: "Inventory Request",
        name: TAB_NAMES.INVENTORY_REQUEST,
        href: "/store/inventory/request",
        icon: InventoryRequestIcon,
      },
    ],
  },
  {
    label: "Membership Management",
    name: TAB_NAMES.MEMBERSHIP_MANAGEMENT,
    href: "/store/memberships",
    icon: MembershipIcon,
  },
  {
    label: "Coupon Management",
    name: TAB_NAMES.COUPON_MANAGEMENT,
    href: "/store/coupons",
    icon: VoucherIcon,
  },
  {
    label: "Enquiry Management",
    name: TAB_NAMES.ENQUIRY_MANAGEMENT,
    href: "/store/enquiries",
    icon: EnquiryIcon,
  },
  {
    label: "Billing",
    name: TAB_NAMES.BILLING,
    href: "/store/billing",
    icon: BillingIcon,
  },
  {
    label: "Withdraw",
    name: TAB_NAMES.WITHDRAW,
    href: "/store/withdraw",
    icon: WithdrawIcon,
  },
  {
    label: "Expenses",
    name: TAB_NAMES.EXPENSES,
    href: "/store/expenses",
    icon: ExpenseIcon,
  },
  {
    label: "Roles",
    name: TAB_NAMES.ROLES,
    href: "/store/roles",
    icon: RolesIcon,
  },
  {
    label: "Data Export",
    name: TAB_NAMES.DATA_EXPORT,
    href: "/store/data-export",
    icon: DataExportIcon,
  },
  {
    label: "Settings",
    name: TAB_NAMES.SETTINGS,
    icon: SettingsIcon,
    children: [
      {
        label: "Profile",
        name: TAB_NAMES.EDIT_PROFILE_SETTINGS,
        href: "/store/profile/edit",
        icon: UserIcon,
      },
      {
        label: "Stores",
        name: TAB_NAMES.STORES,
        href: "/store/store",
        icon: StoreIcon,
      },
      {
        label: "Taxes Settings",
        name: TAB_NAMES.EDIT_STORE_SETTINGS,
        href: "/store/edit-settings",
        icon: SettingsIcon,
      },
    ],
  },
];

export const ADMINS_VENDOR_TABS = [
  {
    label: "Inventory Management",
    // href: "/store/vendor/inventory",
    icon: RolesIcon,
    children: [
      {
        label: "All Inventory",
        name: TAB_NAMES.ALL_INVENTORY,
        href: "/store/vendor/inventory/all",
        icon: RolesIcon,
      },
      {
        label: "Inventory Request",
        name: TAB_NAMES.INVENTORY_REQUEST,
        href: "/store/vendor/inventory/store",
        icon: RolesIcon,
      },
      // {
      //   label: "Inventory Requst",
      //   name: TAB_NAMES.INVENTORY_REQUEST,
      //   href: "/store/vendor/inventory/request",
      //   icon: RolesIcon,
      // },
    ],
  },
  {
    label: "Vendor Management",
    name: TAB_NAMES.VENDOR_MANAGEMENT,
    href: "/store/vendor/vendors",
    icon: VendorIcon,
  },
  {
    label: "Procurement Request",
    name: TAB_NAMES.PROCUREMENT_REQUEST,
    href: "/store/vendor/procurements",
    icon: ProcurementIcon,
  },
  {
    label: "Purchase Order",
    name: TAB_NAMES.PURCHASE_ORDER,
    href: "/store/vendor/purchase-orders",
    icon: RolesIcon,
  },
];

export const VENDOR_APP_TABS = [
  {
    label: "Dashboard",
    name: TAB_NAMES.DASHBOARD,
    href: "/vendor/dashboard",
    icon: DashboardIcon,
  },
  {
    label: "Products",
    name: TAB_NAMES.PRODUCTS,
    href: "/vendor/products",
    icon: ProductIcon,
  },
  {
    label: "Procurement Request",
    name: TAB_NAMES.PROCUREMENT_REQUEST,
    href: "/vendor/procurements",
    icon: ProcurementIcon,
  },
  {
    label: "Purchase Order",
    name: TAB_NAMES.PURCHASE_ORDER,
    href: "/vendor/purchase-orders",
    icon: RolesIcon,
  },
  {
    label: "Settings",
    name: TAB_NAMES.SETTINGS,
    href: "/vendor/settings",
    icon: SettingsIcon,
  },
];

export const getAdminNavTabs = (
  hasViewAccessToTab: any,
  activeApp: ACTIVE_VIEW,
  activeView: ACTIVE_VIEW
) => {
  if (activeApp === "vendor") {
    return VENDOR_APP_TABS;
  }

  if (activeView === "vendor") {
    return ADMINS_VENDOR_TABS;
  }
  return adminNavOptions.filter((tab) => {
    return (
      // set default access to profile page
      [TAB_NAMES.EDIT_PROFILE_SETTINGS].includes(tab.name) ||
      hasViewAccessToTab(tab.name) ||
      tab?.children?.some((child) => hasViewAccessToTab(child.name))
    );
  });
};
